import React, { useContext } from 'react';
import estilo from './estilo.module.css'
import GitHubProjectsContext from '../../state';

function GitProject() {
 const {data}= useContext(GitHubProjectsContext)

  
  return (
    <div className={estilo.contenido} >
      <h2>Información de los Repositorios:</h2>
      <ul>
        {data.map((repo) => ( 
          <li key={repo.name}>
            <strong>Nombre:</strong> {repo.name} | 
            <strong> Creado:</strong> {new Date(repo.created_at).toLocaleDateString()} | 
            <strong> Lenguaje Principal:</strong> {repo.language}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default GitProject;

